export type ModalsState = {
  viewProject: boolean;
  viewProjectId: string | null;
  viewUser: boolean;
  viewUserId: string;
  solutionTypeModal: boolean;
  createProjectImproveModal: boolean;
  projectStatusModal: boolean;
  msTeamsModal: boolean;
};

export const initialState: ModalsState = {
  viewProject: false,
  viewProjectId: null,
  viewUser: false,
  viewUserId: null,
  solutionTypeModal: false,
  createProjectImproveModal: false,
  projectStatusModal: false,
  msTeamsModal: false,
};
